import { Clapperboard, Film, Heart, Home, Search, Settings, Tv } from 'lucide-react'

export type Section = 'home' | 'movies' | 'series' | 'search' | 'library' | 'settings'

const nav: Array<{ id: Section; label: string; icon: typeof Home }> = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'movies', label: 'Movies', icon: Film },
  { id: 'series', label: 'Series', icon: Tv },
  { id: 'search', label: 'Search', icon: Search },
  { id: 'library', label: 'My list', icon: Heart },
  { id: 'settings', label: 'Settings', icon: Settings },
]

interface Props {
  section: Section
  /** which destinations the admin has switched on, in their order */
  sections?: Section[]
  onChange: (value: Section) => void
  serverOnline: boolean
  serverLabel: string
  clock: string
}

/** On-demand navigation keeps every section one Up press away without taking
 * permanent canvas space. Down returns to the current screen's first control. */
export function TopNavigation({ section, sections, onChange, serverOnline, serverLabel, clock }: Props) {
  const items = sections?.length
    ? sections.map((id) => nav.find((item) => item.id === id)).filter((item): item is typeof nav[number] => Boolean(item))
    : nav

  return (
    <header className="top-nav">
      <div className="top-brand" aria-label="Vela">
        <span className="brand-mark"><i /></span>
        <strong>VELA</strong>
      </div>
      <nav aria-label="Primary navigation" data-nav-group="row" data-nav-key="top-navigation">
        {items.map((item) => {
          const Icon = item.icon
          return (
            <button
              key={item.id}
              className={`top-nav-item${section === item.id ? ' active' : ''}`}
              data-focusable
              data-section={item.id}
              aria-current={section === item.id ? 'page' : undefined}
              onClick={() => onChange(item.id)}
            >
              <Icon size="1.75rem" strokeWidth={2.1} />
              <span>{item.label}</span>
            </button>
          )
        })}
      </nav>
      <div className="top-status">
        {serverLabel ? <span className={serverOnline ? 'online' : 'offline'}><i /><Clapperboard size="1.5rem" />{serverLabel}</span> : null}
        {clock ? <time>{clock}</time> : null}
      </div>
    </header>
  )
}
